import Api from '@/api'

const api = new Api()
const apiSpec = api
  .sales()
  .bid()
  .spec()

export default {
  // GETs ===================================================
  async fetchAnalysis({ commit }, payload) {
    try {
      const { bidNumber, site } = payload
      const resp = await apiSpec.analysis(bidNumber).fetch(site)
      const response = resp.data.data
      commit('setAnalysis', response.analysis ? response.analysis : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async fetchAllByBidNumber({ commit }, payload) {
    try {
      const { bidNumber } = payload
      const resp = await apiSpec.analysis(bidNumber).fetchAll()
      const response = resp.data.data
      commit('setAllOfBidNumber', response.analysis ? { bidNumber, analysis: response.analysis } : null)
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async addAnalysis({ commit }, payload) {
    try {
      const { bidNumber, site } = payload
      const resp = await apiSpec.analysis(bidNumber).add(site, payload)
      const response = resp.data.data
      commit('newAnalysis', response.analysis ? response.analysis : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async editAnalysis({ commit }, payload) {
    try {
      const { bidNumber, site, id } = payload
      const resp = await apiSpec.analysis(bidNumber).edit(id, site, payload)
      const response = resp.data.data
      commit('update', response.analysis ? response.analysis : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async deleteAnalysis({ commit }, payload) {
    try {
      const { bidNumber, site, id } = payload
      const resp = await apiSpec.analysis(bidNumber).delete(site, id)
      const response = resp.data.data
      commit('removeAnalysis', response.analysis ? response.analysis : null)
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async addPeriod({ commit }, payload) {
    try {
      const { bidNumber, site, analysis, type, period } = payload
      const resp = await apiSpec
        .analysis(bidNumber)
        .period(site, analysis, type)
        .add(period)
      const response = resp.data.data
      commit('newPeriod', response.period ? { period: response.period, type, id: analysis } : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async transferPeriodTo({ commit }, payload) {
    // transfer Capture Period in to Analysis
    try {
      const { bidNumber, site, type, analysis } = payload
      const resp = await apiSpec
        .analysis(bidNumber)
        .period(site, analysis, type)
        .transfer()
      const response = resp.data.data
      commit('newPeriod', response.period ? { period: response.period, type: 'analysis', id: analysis } : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async deletePeriod({ commit }, payload) {
    try {
      const { bidNumber, site, analysis, type, id } = payload
      const resp = await apiSpec
        .analysis(bidNumber)
        .period(site, analysis, type)
        .delete(id)
      const response = resp.data.data
      commit('removePeriod', response.period ? { period: response.period, type } : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async deleteAllPeriods({ commit }, payload) {
    try {
      const { bidNumber, site, analysis, type } = payload
      const resp = await apiSpec
        .analysis(bidNumber)
        .period(site, analysis, type)
        .deleteAll()
      const response = resp.data.data
      commit('removeAllPeriods', response.period ? { period: response.period, type } : [])
      commit('Dashboard/setFeedback', response, { root: true })
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
  async deleteAllAnalysisPeriods({ commit }, payload) {
    try {
      const { bidNumber, site } = payload
      const resp = await apiSpec.analysis(bidNumber).deleteAllPeriods(site)
      const response = resp.data.data
      commit('setAnalysis', response.analysis ? response.analysis : [])
      return resp
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
